import {
	Id,
	LaravelResponse,
	PaginatedListFetcherConfig,
	keyToUrl,
	withDestroyEndpoint,
	withStoreEndpoint,
} from "@dgs/core";
import axios from "axios";
import { EventListOverviewResource, EventSaveRequest } from "../../../../shared/types/event";
import { CancelEventUserParticipationRequest, CreateEventUserRequestRequest, EventDetailResource } from "../types";

const baseKey = ["events"];
const detailsKey = (eventId: Id) => [...baseKey, `${eventId}`, "details"];
const userRequestsKey = (eventId: Id) => [...baseKey, `${eventId}`, "user-requests"];
const participationKey = (eventId: Id) => [...baseKey, `${eventId}`, "participation"];
const participateKey = (eventId: Id) => [...baseKey, `${eventId}`, "participate"];

const listOverviewKey = [...baseKey, "overview"];

export const eventService = {
	baseKey,
	listOverviewKey,
	listOverview: (
		config: PaginatedListFetcherConfig<EventListOverviewResource>,
		filterId: Id | null,
		showOnlyOwnEvents: boolean,
	) =>
		axios.get<LaravelResponse<EventListOverviewResource[]>>(keyToUrl(baseKey), {
			params: {
				...config.searchParams,
				...config.pageParams,
				filterId,
				showOnlyOwnEvents: showOnlyOwnEvents ? "1" : "0",
			},
		}),
	detailsKey,
	getDetails: (eventId: Id) => axios.get<LaravelResponse<EventDetailResource>>(keyToUrl(detailsKey(eventId))),
	createUserRequest: (eventId: Id, request: CreateEventUserRequestRequest) =>
		axios.post<undefined>(keyToUrl(userRequestsKey(eventId)), request),
	participate: (eventId: Id) => axios.put<undefined>(keyToUrl(participateKey(eventId))),
	cancelParticipationWithInquiry: (eventId: Id, request: CancelEventUserParticipationRequest) =>
		axios.post<undefined>(keyToUrl(participationKey(eventId)), request),
	cancelParticipation: (eventId: Id) => axios.delete<undefined>(keyToUrl(participationKey(eventId))),
	...withStoreEndpoint<EventSaveRequest>(baseKey),
	...withDestroyEndpoint(baseKey),
};
